import React from 'react';
import { bool, shape, string } from 'prop-types';

const CanseledColor = ({
  className = '',
  notUseClass = false,
  color = '#696f88',
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={{ color, ...style }} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M7.00033 1.16699C3.77449 1.16699 1.16699 3.77449 1.16699 7.00033C1.16699 10.2262 3.77449 12.8337 7.00033 12.8337C10.2262 12.8337 12.8337 10.2262 12.8337 7.00033C12.8337 3.77449 10.2262 1.16699 7.00033 1.16699ZM7.00033 11.667C4.42783 11.667 2.33366 9.57283 2.33366 7.00033C2.33366 4.42783 4.42783 2.33366 7.00033 2.33366C9.57283 2.33366 11.667 4.42783 11.667 7.00033C11.667 9.57283 9.57283 11.667 7.00033 11.667ZM7.00033 6.17783L9.09449 4.08366L9.91699 4.90616L7.82283 7.00033L9.91699 9.09449L9.09449 9.91699L7.00033 7.82283L4.90616 9.91699L4.08366 9.09449L6.17783 7.00033L4.08366 4.90616L4.90616 4.08366L7.00033 6.17783Z" fill="currentColor" />
  </svg>
);

CanseledColor.propTypes = {
  className: string,
  notUseClass: bool,
  color: string,
  style: shape({}),
};

export default CanseledColor;
